<template>
  <div class="side-bar">
    <a-menu ref="menu" mode="inline" @click="menuItemSelect" :selected-keys="selectedKeys" :openKeys.sync="openKeys">
      <sidebar-items :item="value" v-for="value in $store.state.menuList[0].children" :key="value.url || value.name"></sidebar-items>
    </a-menu>
  </div>
</template>

<script>
  import SidebarItems from '@/components/SidebarItems.vue';

  export default {
    name: 'SideBar',
    data() {
      return {
        selectedKeys: [],
        openKeys: []
      }
    },
    components: {
      SidebarItems,
    },
    watch: {
      $route: {
        handler(newValue, oldValue) {
          this.selectedKeys = this.$route.meta.path.filter(val => !val.type || val.type > -1).map(val => val.url || val.name).concat(this.$route.path);
          this.openKeys = this.$route.meta.path.filter(val => !val.type || val.type > -1).map(val => val.name);
        },
        immediate: true
      }
    },
    methods: {
      menuItemSelect(item) {
        let key = item.key;
        if (key !== this.$route.path) {
          this.$router.push(key);
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .side-bar {
    
  }
</style>